<template>
  <div class="mainContaner full_w">

    <loading v-show="showLoading"></loading>

    <div class="card_detail" v-show="!showLoading">

      <div class="card_detail_content">

        <div class="card_detail_content_top">

          <div class="card_detail_content_swipe">

            <van-swipe :autoplay="3000" class="goods-detail-banner">
              <van-swipe-item v-for="(image,index) in productDetail.imageList" :key="index" style="width:23.4375rem;">
                <van-image class="banner_item" fit="cover" :src="image"/>
              </van-swipe-item>
            </van-swipe>

          </div>

          <div class="card_detail_content_basic">

            <div class="card_detail_content_basic_top">
              <div class="card_detail_content_prcie zt20">
                ¥{{productDetail.price}}
              </div>

              <div class="card_detail_content_basic_image" style="margin-left: 0.625rem;" @click="collection()">
                <img src="@/images/collection@3x.png" v-if="isCollection == 0"/>
                <img src="@/images/icon_Selection_Collection@3x.png" v-if="isCollection == 1"/>
              </div>
              <div class="card_detail_content_basic_image" @click="showShareSheet=true">
                <img src="@/images/share@3x.png"/>
              </div>

              <van-popup v-model="showShareSheet" round position="bottom" :style="{ height: '20%' }" >
                <div class="ovh" style="padding: 1.5rem 2rem 0 2rem">
                  <div class="ovh fl tc" @click="shareFriend()">
                    <img style="width: 4rem" src="@/images/share_icon_1.png">
                    <p class="zt14 tc clear_style" style="color: #939598;width: 5rem;line-height: 1rem">发送给朋友</p>
                  </div>
                  <!--<div class="ovh fl tc" @click="onSelectAction()">-->
                    <!--<img style="width: 4rem" src="@/images/share_icon_2.png">-->
                    <!--<p class="zt14 tc clear_style" style="color: #939598;width: 9rem;line-height: 1rem">生成海报</p>-->
                  <!--</div>-->
                  <div class="ovh fl tc" @click="showShareSheet=false">
                    <img style="width: 4rem" src="@/images/share_icon_3.png">
                    <p class="zt14 tc clear_style" style="color: #939598;width: 5rem;line-height: 1rem">取消分享</p>
                  </div>
                </div>
              </van-popup>

            </div>

            <div class="card_detail_content_name zt14">
              {{productDetail.productName}}
            </div>
            <div class="card_detail_content_num zt12">
              <div class="card_detail_content_num_sales">
                已售{{productDetail.soldNumber}}件
              </div>
              <div class="card_detail_content_num_kucun">
                库存 {{productDetail.InventoryQuantity}}件
              </div>
            </div>

          </div>

        </div>

        <div class="card_margin_show">

        </div>

        <div class="card_detail_content_bottom">
          <div class="card_detail_content_bottom_title zt12">
            商品详情
            <div class="card_detail_content_bottom_line">

            </div>
          </div>
          <div class="card_detail_content_bottom_image">
            <div v-html="description" class="goods-detail-recommended-desc"></div>
          </div>
        </div>
      </div>




    </div>

    <div class="card_detail_sure_button boxshadow" @click="showBuy()">
      <button>立即购买</button>
    </div>


    <van-overlay :show="showBuyView" @click="showBuyView = false">
      <div class="wrapper" @click.stop>

        <div class="physical_card-spec-goods" >

          <div class="card_detail_spec_title">
            订单确认
          </div>

          <div style="width:20rem;margin: 0 auto;">
            <div class="physical_card-spec-goodsImg">
              <van-image :src="productDetail.imageList[0]" fit="cover" v-if="productDetail.imageList">
                <template v-slot:error></template>
              </van-image>
            </div>
            <div class="physical_card-spec-goodsInfo">
              <div class="physical_card-spec-goodsInfo-price">
                {{productDetail.productName}}
              </div>
              <div class="physical_card-spec-goodsInfo-stock">
                库存:{{productDetail.InventoryQuantity}}
              </div>
              <div class="physical_card-spec-goodsInfo-spec">
                <div style="color:red;text-align: left;display: inline-block;vertical-align: top;">
                  ¥{{productDetail.price}}
                </div>
                <div class="card_detail_spec_changeNum">
                  <button class="card_detail_spec_low" @click="lowNum()">-</button>
                  <div class="card_detail_spec_num">{{buyNum}}</div>
                  <button class="card_detail_spec_low" @click="addNum()">+</button>
                </div>
              </div>

            </div>
          </div>

          <div class="physical_card_add_button">
            <button @click="showBuyView = false" class="physical_card_add_button_cancel">取消</button>
            <button @click="addCar()" class="physical_card_add_button_sure">确定</button>
          </div>
        </div>

      </div>

    </van-overlay>


    <van-overlay :show="showPopView" @click="showPopView = false" >
      <div class="ovh fr tr" style="margin-right: 4rem;margin-top: 1rem">
        <img class="fr" style="width: 2rem;margin-left: 1rem" src="@/images/share.png">
        <p class="zt16 fr white ovh tr">点击菜单分享给好友，立即赚取收益</p>
      </div>
    </van-overlay>

    <van-overlay :show="showImgView">
      <div v-show="!showShareLoading">
        <p v-if="showImgView" style="position: absolute;right: 0;margin: 0rem"><van-button @click="showImgView=false" color="#666" icon="close" type="default" size="small">关闭分享</van-button></p>
        <img class="full_w" :src="imgSrcUrl">
        <div v-if="showImgView" class="ovh zt16 tc white full_w" style="position: absolute;background-color: #EB84AB;height: 3rem;line-height: 3rem;margin-top: -3rem">. 长按保存图片 .</div>
      </div>
      <van-loading style="margin-top: 15rem" v-show="showShareLoading" size="24px" vertical>生成海报中...</van-loading>
    </van-overlay>

  </div>




</template>

<script>

  import Vue from 'vue'
  import { storeName,prodCatalogId,shareUrl,severUrl,shareCardUrl,wxUrl} from '@/router/Constant'
  import { wxApi } from '@/router/wechat.js'
  import { getProductInfo,getProductDescription,cartInsBuy,updateProductCollectInfo,boundTwoLevel,getShareInfo,getDistributionDetail,shareGetKcion} from '@/router/api'
  import { Loading, Button , Swipe,Image,SwipeItem , Toast,Dialog,Overlay,Popup} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import { setStore,getStore,getCookie,setCookie,GetQueryString ,setMiniProgramShare} from '@/utils/mUtil';

    export default {
      name: "physicalCardDetail",
      data(){
        return {
          productId:this.$route.query.goodsId,
          token:getStore('externalLoginKey'),
          productStoreId:storeName,
          prodCatalogId:prodCatalogId,
          productDetail:{},
          description:'',
          showLoading:true,
          isCollection:0,
          buyNum:1,
          showBuyView:false,

          showShareSheet: false,
          showPopView:false,
          showImgView:false,
          showShareLoading:false,
          shareActions: [{ name: '发送给朋友' }, { name: '生成海报' }],
          imgSrcUrl:'',
          distributionInfo:{},
        }
      },

      mounted () {

        console.log("productId====="+this.productId)
        this.init()

      },

      components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Image.name]: Image,
        [Toast.name]: Toast,
        [Button.name]: Button,
        [Loading.name]:Loading,
        loading,
        [Dialog.name]:Dialog,
        [Overlay.name]:Overlay,
        [Popup.name]:Popup
      },

      methods:{

        async init(){
          this.getProductInfo()
          this.getProductDescription()
          this.getPartyId()
        },

        //绑定分销人
        getPartyId:function() {

          if(window.location.href.indexOf('partyId')!=-1){
            if(getStore('islogIn') != 'true'){
              //用户未登陆
              // this.dialogAction('是否登陆会员系统');
            }else{
              //用户已登陆

              // 获得参数
              var currentUrl = window.location.href;
              var allParamArr = currentUrl.split("&");
              var partyId = "";
              for (var i = 0; i < allParamArr.length; i++) {
                if (allParamArr[i].indexOf("partyId") != -1) {
                  partyId = allParamArr[i].split("=")[1];
                  break;
                }
              }

              var param = {
                partyId:partyId,
                externalLoginKey:this.token
              }
              console.log('param')
              console.log(param)

              boundTwoLevel({partyId:partyId,externalLoginKey:this.token})
                .then(res => {
                  console.log(res)
                  if(res._ERROR_MESSAGE_){
                    Toast({message:res._ERROR_MESSAGE_})
                  }else{
                    console.log('绑定成功')
                  }
                })
                .catch(err => {
                  console.log(err);
                });
            }
          }else{
            console.log('未获取到partyId')
          }

          // if (getStore('islogIn') != 'true') {
          //   //this.dialogAction('跳转购物车需要登录，是否现在登录？');
          // } else{
          // }
        },

        //获取当前分销人信息
        getDetail:function(){
          let param = {
            externalLoginKey: this.token,
          }
          getDistributionDetail(param)
            .then(res => {
              console.log("getDistributionDetail");
              console.log(res);
              if(!res._ERROR_MESSAGE_){
                //成功
                this.distributionInfo = res.resultMap
                this.creatQiYuAction()
              }else{
                Toast({message:res._ERROR_MESSAGE_})
              }
              setMiniProgramShare(this.productDetail.productName,this.productDetail.imageList[0],wxUrl+encodeURIComponent(shareCardUrl+'physicalCardDetail')+'&goodsId='+this.productId+'&partyId='+this.distributionInfo.partyId)
            })
            .catch(err => {
              setMiniProgramShare(this.productDetail.productName,this.productDetail.imageList[0],wxUrl+encodeURIComponent(shareCardUrl+'physicalCardDetail')+'&goodsId='+this.productId+'&partyId='+this.distributionInfo.partyId)
              console.log(err);
            });
        },


        //获取产品基础数据
        getProductInfo:function(){
          let param = {
            externalLoginKey: this.token,
            productId: this.productId,
            productStoreId:this.productStoreId,
            prodCatalogId:prodCatalogId
          }
          getProductInfo(param)
            .then(res => {
              console.log('getProductInfo');
              console.log(res);
              this.productDetail = res.product;
              this.isCollection = this.productDetail.isCollect

              this.getDetail()

              setTimeout(() => {
                this.showLoading = false;
              }, 1000);
            })
            .catch(err => {
              console.log(err);
            });
        },


        //产品图文详情
        getProductDescription:function(){
          getProductDescription({productId:this.productId,prodCatalogId:prodCatalogId,}).then(res => {
            console.log(res)
            this.description = res.description;
          }).catch(err => {
            console.log(err)
          })
        },

        //产品收藏事件
        collection:function () {
          if (getStore('islogIn') != 'true') {
            this.dialogAction('收藏商品需要登录，是否现在登录？');
          } else{
            //用户已登陆
            this.collect()
          }
        },

        //转发给朋友
        shareFriend:function(){
          this.showShareSheet=false
          this.showPopView = true
          this.shareGetKcion()
        },

        //文章转发获得K币
        shareGetKcion:function(){
          shareGetKcion({externalLoginKey:this.token})
            .then(res => {
              console.log('转发成功')
              console.log(res)
            })
            .catch(err => {
              console.log(err);
            });
        },


        //用户点击确定登陆按钮
        dialogAction(msg){
          Dialog.confirm({
            message: msg
          }).then(() => {
            if (getStore('fromType')=='mini') {
            wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          } else {
              wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          }
          }).catch(() => {

          });
        },


        //执行用户收藏方法
        collect:function(){
          let paramList = {
            externalLoginKey: this.token,
            productId: this.productId,
            productStoreId: storeName,
          }
          updateProductCollectInfo(paramList).then(res => {
            console.log(res)
            if(res._EVENT_MESSAGE){
              if(this.isCollection == 0){
                this.isCollection = 1
                Toast({message:'收藏成功'})
              }else{
                this.isCollection = 0
                Toast({message:'取消收藏成功'})
              }
            }else{
              if(this.isCollection == 0){
                Toast({message:'收藏失败'})
              }else{
                Toast({message:'取消收藏失败'})
              }
            }

          }).catch(err =>{
            console.log(err)
          })
        },

        showBuy:function(){
          this.showBuyView = true
        },

        //用户添加产品数量
        addNum:function () {
          if(this.buyNum<this.productDetail.InventoryQuantity){
            this.buyNum++
          }else{
            Toast({message:'很遗憾，商品没有库存了'})
          }
        },

        //用户减少产品数量
        lowNum:function () {
          if(this.buyNum>1){
            this.buyNum--
          }else{
            Toast({message:'已是最小购买量'})
          }
        },


        //用户点击规格确定按钮
        addCar:function () {
          if(this.buyNum>this.productDetail.InventoryQuantity){
            Toast('此商品没有库存了')
          }else {
            this.cartInsBuy()
          }
        },


        //用户点击立即购买
        cartInsBuy:function(){
          let paramList = {
            externalLoginKey: this.token,
            productId: this.productDetail.productId,
            productStoreId: storeName,
            quantity:this.buyNum,
            prodCatalogId:prodCatalogId,
          }
          console.log(paramList)
          cartInsBuy(paramList).then(res => {
            console.log(res)
            console.log('cartInsBuy')
            if(res._ERROR_MESSAGE_){
              Toast({message:res._ERROR_MESSAGE_})
              this.showBuyView = false
            }else{
              Toast({message:'添加成功'})
              document.querySelector('body').style.overflow = 'scroll'
              this.$router.push({path:'/cardComfirm',query:{type:'shiti'}})
            }

          }).catch(err =>{
            console.log(err)
          })
        },

        onSelectAction() {
          // 默认情况下点击选项时不会自动收起
          // 可以通过 close-on-click-action 属性开启自动收起
          this.showShareSheet = false;
          console.log("生成海报中")
          this.showImgView = true
          this.showShareLoading = true
          this.getShareInfo();
        },

        onCancel(){
          this.showShareSheet = false;
        },

        getShareInfo() {
          var qrCodeContent = shareUrl+'?/goodsDetail?goodsId='+this.productDetail.productId+'&partyId='+this.distributionInfo.partyId
          console.log({externalLoginKey:getStore('externalLoginKey'),qrCodeContent:qrCodeContent,productStoreId: storeName})
          getShareInfo({externalLoginKey:getStore('externalLoginKey'),qrCodeContent:qrCodeContent,productStoreId: storeName})
            .then(res => {
              console.log("getShareInfo")
              console.log(res)
              if (res._ERROR_MESSAGE_) {
                Toast.fail(res._ERROR_MESSAGE_);
              } else {
                console.log(res._EVENT_MESSAGE_)

                // 当店铺是零售的时候，零售的店铺需要的参数为二维码图片和头部的图片
                if (storeName == 'OnlineStore') {
                  if (res.qrImg != '' && res.headImg != '' && res.qrImg != undefined && res.headImg != undefined) {
                    setTimeout(() => {
                      this.doMyCanvas(res.qrImg,res.headImg)
                    }, 1000);
                  } else {
                    Toast.fail("请联系管理员完成分享配置")
                    this.showShareLoading = false
                    this.showImgView = false
                  }
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        },

        doMyCanvas(imgQr,headImg) {
          var param = {
            width: window.outerWidth * 2, // 卡牌宽度
            height: window.outerHeight * 2, // 卡
            imgBG: this.productDetail.imageList[0], //背景
            imgBGMask:shareMaskBg,
            imgHead:headImg,
            imgQr: imgQr, // 卡牌底部二维码
          };

          console.log(param)

          // var c= document.getElementById('canvas');
          var c = document.createElement('canvas');
          var ctx = c.getContext("2d");

          c.width = param.width;
          c.height = param.height;
          var myCanvas = c;
          var img = new Image();
          img.crossOrigin = 'Anonymous'
          img.src = param.imgBG;
          img.onload = () => {

            // 设置背景为白色
            var imageData = ctx.getImageData(0, 0, c.width, c.height);
            for(var i = 0; i < imageData.data.length; i += 4) {
              // 当该像素是透明的,则设置成白色
              if(imageData.data[i + 3] == 0) {
                imageData.data[i] = 255;
                imageData.data[i + 1] = 255;
                imageData.data[i + 2] = 255;
                imageData.data[i + 3] = 255;
              }
            }
            ctx.putImageData(imageData, 0, 0);

            var bGH = 945
            var startX = 50 + (param.width - 750)/2
            console.log("param.height" + param.height)
            console.log("startY======" + startY)
            var startY = (param.height - bGH - 250) / 2  // 最小的内容区域为1100px

            // 设置背景图
            var goodsImgWidth = param.width * 2
            var goodsImgHeight = param.width * 2
            var oData,newSrc;
            ctx.drawImage(img, -(goodsImgWidth-param.width)/2, -(goodsImgHeight-param.width)/2/2 + startY/2, goodsImgWidth, goodsImgHeight);
            oData = ctx.getImageData(0,0,param.width,param.height);
            newSrc = this.gaussBlur(oData);
            ctx.putImageData(newSrc, 0, 0);

            // 设置蒙版遮罩
            var maskImgW = param.width
            var maskImgH = param.height
            var maskImg = new Image()
            maskImg.crossOrigin = 'Anonymous'
            maskImg.src = param.imgBGMask
            maskImg.onload = () => {

              ctx.drawImage(maskImg, 0, 0, maskImgW, maskImgH);

              // 画圆角矩形
              this.fillRoundRect(ctx,startX,startY,param.width - (startX * 2),bGH,20)

              startX += 30
              startY += 40
              // 设置商品头图
              var headImg = new Image();
              headImg.crossOrigin = 'Anonymous'
              headImg.src = param.imgHead
              headImg.onload = () => {
                console.log(startX,startY,param.width - startX*2, 100)
                ctx.drawImage(headImg, startX,startY,param.width - startX*2, 100);
                // 设置商品主图
                startY += 100 + 30
                var goodsImg = new Image();
                goodsImg.crossOrigin = 'Anonymous'
                goodsImg.src = param.imgBG
                goodsImg.onload = () => {
                  ctx.drawImage(goodsImg, startX, startY, param.width - startX*2, param.width - startX*2);

                  // 设置商品名称
                  startY += (param.width - startX*2 + 60)
                  ctx.font = 'normal 32px Microsoft YaHei';
                  ctx.textAlign = 'left';
                  ctx.textBaseline = 'bottom';
                  ctx.fillStyle = '#6d6e70';
                  ctx.fillText(this.productDetail.productName, startX, startY);

                  // 设置商品价格
                  startY += 50
                  ctx.font = 'normal 32px Microsoft YaHei';
                  ctx.textAlign = 'left';
                  ctx.textBaseline = 'bottom';
                  ctx.fillStyle = '#EB84AB';
                  ctx.fillText("¥ " + this.productDetail.price, startX, startY);

                  // 设置分享人名称
                  ctx.font = 'normal 32px Microsoft YaHei';
                  ctx.textAlign = 'right';
                  ctx.textBaseline = 'bottom';
                  ctx.fillStyle = '#6d6e70';
                  ctx.fillText(this.distributionInfo.name, param.width - startX, startY);

                  // 设置提示
                  startY += 50
                  ctx.font = 'normal 28px Microsoft YaHei';
                  ctx.textAlign = 'right';
                  ctx.textBaseline = 'bottom';
                  ctx.fillStyle = '#b2b3b6';
                  ctx.fillText('"分享给你我的快乐！"', param.width - startX, startY);

                  // 画二维码圆角矩形
                  var qrw = 150
                  startY += 40
                  startX += (param.width - startX * 2 - qrw)/2
                  this.fillRoundRect(ctx,startX,startY,qrw,qrw,20)

                  // 设置二维码图
                  startY += 5
                  startX += 5
                  var qrImg = new Image();
                  qrImg.crossOrigin = 'Anonymous'
                  qrImg.src = param.imgQr
                  qrImg.onload = () => {
                    ctx.drawImage(qrImg, startX, startY, qrw-10, qrw-10);

                    // 设置长按二维码提示
                    startY += qrw + 50
                    startX = param.width / 2
                    ctx.font = 'normal 28px Microsoft YaHei';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'bottom';
                    ctx.fillStyle = '#fff';
                    ctx.fillText("长按识别二维码 发现更多精彩", startX, startY);

                    var imgUrl = c.toDataURL('image/jpeg', 2.0);
                    console.log(imgUrl)
                    this.showShareLoading = false
                    this.imgSrcUrl = imgUrl
                  }
                }
              }
            }
          };
        },

        fillRoundRect(cxt, x, y, width, height, radius) {
          //圆的直径必然要小于矩形的宽高
          if (2 * radius > width || 2 * radius > height) { return false; }

          cxt.save();
          cxt.translate(x, y);
          //绘制圆角矩形的各个边
          this.drawRoundRectPath(cxt, width, height, radius);
          cxt.fillStyle = "white"; //若是给定了值就用给定的值否则给予默认值
          cxt.fill();
          cxt.restore();
        },

        drawRoundRectPath(cxt, width, height,radius) {
          var  r0 = radius,r1 = radius,r2 = radius,r3 = radius;
          cxt.beginPath(0);
          //从右下角顺时针绘制，弧度从0到1/2PI
          cxt.arc(width - r0, height - r0, r0, 0, Math.PI / 2);

          //矩形下边线
          cxt.lineTo(r1, height);

          //左下角圆弧，弧度从1/2PI到PI
          cxt.arc(r1, height - r1, r1, Math.PI / 2, Math.PI);

          //矩形左边线
          cxt.lineTo(0, r2);

          //左上角圆弧，弧度从PI到3/2PI
          cxt.arc(r2, r2, r2, Math.PI, Math.PI * 3 / 2);

          //上边线
          cxt.lineTo(width - r3, 0);

          //右上角圆弧
          cxt.arc(width - r3, r3, r3, Math.PI * 3 / 2, Math.PI * 2);

          //右边线
          cxt.lineTo(width, height - r3);
          cxt.closePath();
        },

        gaussBlur(imgData) {
          var pixes = imgData.data;
          var width = imgData.width;
          var height = imgData.height;
          var gaussMatrix = [],
            gaussSum = 0,
            x, y,
            r, g, b, a,
            i, j, k, len;

          var radius = 50;
          var sigma = 10;

          a = 1 / (Math.sqrt(2 * Math.PI) * sigma);
          b = -1 / (2 * sigma * sigma);
          //生成高斯矩阵
          for (i = 0, x = -radius; x <= radius; x++, i++){
            g = a * Math.exp(b * x * x);
            gaussMatrix[i] = g;
            gaussSum += g;

          }
          //归一化, 保证高斯矩阵的值在[0,1]之间
          for (i = 0, len = gaussMatrix.length; i < len; i++) {
            gaussMatrix[i] /= gaussSum;
          }
          //x 方向一维高斯运算
          for (y = 0; y < height; y++) {
            for (x = 0; x < width; x++) {
              r = g = b = a = 0;
              gaussSum = 0;
              for(j = -radius; j <= radius; j++){
                k = x + j;
                if(k >= 0 && k < width){//确保 k 没超出 x 的范围
                  //r,g,b,a 四个一组
                  i = (y * width + k) * 4;
                  r += pixes[i] * gaussMatrix[j + radius];
                  g += pixes[i + 1] * gaussMatrix[j + radius];
                  b += pixes[i + 2] * gaussMatrix[j + radius];
                  // a += pixes[i + 3] * gaussMatrix[j];
                  gaussSum += gaussMatrix[j + radius];
                }
              }
              i = (y * width + x) * 4;
              // 除以 gaussSum 是为了消除处于边缘的像素, 高斯运算不足的问题
              // console.log(gaussSum)
              pixes[i] = r / gaussSum;
              pixes[i + 1] = g / gaussSum;
              pixes[i + 2] = b / gaussSum;
              // pixes[i + 3] = a ;
            }
          }
          //y 方向一维高斯运算
          for (x = 0; x < width; x++) {
            for (y = 0; y < height; y++) {
              r = g = b = a = 0;
              gaussSum = 0;
              for(j = -radius; j <= radius; j++){
                k = y + j;
                if(k >= 0 && k < height){//确保 k 没超出 y 的范围
                  i = (k * width + x) * 4;
                  r += pixes[i] * gaussMatrix[j + radius];
                  g += pixes[i + 1] * gaussMatrix[j + radius];
                  b += pixes[i + 2] * gaussMatrix[j + radius];
                  // a += pixes[i + 3] * gaussMatrix[j];
                  gaussSum += gaussMatrix[j + radius];
                }
              }
              i = (y * width + x) * 4;
              pixes[i] = r / gaussSum;
              pixes[i + 1] = g / gaussSum;
              pixes[i + 2] = b / gaussSum;
            }
          }
          //end
          return imgData;
        }



      }


    }
</script>

<style>

  .mainContaner {
    position: absolute;top: 0;
  }

  .goods-detail-banner{
    height: 23.4375rem;
    background-color: white;
  }
  .banner_item {
    width: 100%;
    height: 100%;
  }
  .banner_item img{
    border-radius:0;
    width:100%;
    height: 100%;
  }


  .card_detail{
    padding-bottom: 3.75rem;
  }
  .card_detail_content{
    width:100%;
  }
  .card_detail_content_top{
    width:100%;
  }
  .card_detail_content_basic_top{
    height: 3.125rem;
    line-height: 3.125rem;
  }
  .card_detail_content_swipe{
    width:100%;
    height: 23.4375rem;
  }
  .slide-image{
    width:100%;
    height: 100%;
  }
  .card_detail_content_basic{
    width:21.875rem;
    margin: 0 auto;
  }
  .card_detail_content_prcie{
    color:#E50113;
    display: inline-block;
    vertical-align: top;
    font-weight: bold;
  }
  .card_detail_content_basic_image{
    display: inline-block;
    vertical-align: top;
    float:right;
    margin-top: 0.8125rem;
  }
  .card_detail_content_basic_image img{
    width:1.25rem;
    height: 1.25rem;
    display: inline-block;
    vertical-align: top;
  }
  .card_detail_content_name{
    width:100%;
    color:#000000 ;
    line-height: 0.625rem;
    font-weight: bold;
    margin-bottom: 0.625rem;
  }
  .card_detail_content_num{
    width:100%;
    color:#999999 ;
    height: 0.9125rem;
    line-height: 0.9125rem;
    margin-bottom: 0.9125rem;
  }
  .card_detail_content_num_sales{
    width:calc(100% / 2);
    display: inline-block;
    vertical-align: top;
    text-align: left;
  }
  .card_detail_content_num_kucun{
    width:calc(100% / 2);
    display: inline-block;
    vertical-align: top;
    text-align: right;
    float: right;
  }
  .card_margin_show{
    width:100%;
    height: 0.9125rem;
    background-color: #efefef;
  }
  .card_detail_content_bottom{
    width:100%;
    margin-bottom:3.0625rem;
  }
  .card_detail_content_bottom_title{
    width:21.875rem;
    margin: 0 auto;
    height: 2.5rem;
    line-height: 2.5rem;
    color:#2E2E2E ;
  }
  .card_detail_content_bottom_line{
    width:2.8125rem;
    height: 3px;
    background-color: lightpink;
    position: relative;
    top: -1rem;
    opacity: 0.5;
  }
  .card_detail_content_bottom_image{
    width:100%;
  }
  .card_detail_content_bottom_image image{
    width:100%;
    height: 100%;
  }
  .card_detail_sure_button{
    width:100%;
    height: 3.59rem;
    position: fixed;
    bottom: 0;
    text-align: center;
    background-color: white;
  }
  .card_detail_sure_button button{
    width:10.625rem;
    height: 2.343rem;
    border-radius: 1.157rem;
    background-color: #EB7AA0;
    margin: 0.625rem auto;
    color:white;
    font-size: 0.9125rem;
    text-align: center;
    line-height: 2.243rem;
  }
  .goods-detail-recommended-desc{
    width:21.4375rem;
    margin: 0 auto;
  }


  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  /*商品规格*/
  .physical_card-spec-goods{
    width:21.4375rem;
    margin: 0 auto;
    border-bottom: 1px solid #e5e5e5;
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
    background-color: white;
    border-radius: 0.625rem;
  }
  .physical_card-spec-goodsImg{
    width:6.25rem;
    height: 6.25rem;
    display: inline-block;
    vertical-align: top;
    margin-right: 0.625rem;
  }
  .physical_card-spec-goodsImg .van-image{
    width:100%;
    height: 100%;
  }
  .physical_card-spec-goodsInfo{
    width:calc(100% - 7.25rem);
    display: inline-block;
    vertical-align: top;
  }
  .physical_card-spec-goodsInfo-price{
    font-size:1rem;
    color:#333312;
    margin-bottom: 2rem;
  }
  .physical_card-spec-goodsInfo-stock{
    font-size: 0.875rem;
    color:#666;
    margin-bottom: 0.625rem;
  }
  .physical_card-spec-goodsInfo-spec{
    font-size: 0.875rem;
    color:#666;
  }
  .physical_card-spec-list-each-list div{
    display: inline-block;
    vertical-align: top;
    height: 1.5rem;
    line-height: 1.5rem;
    border-radius: 2rem;
    margin-bottom: 0.625rem;
    margin-right: 0.625rem;
    background-color: white;
    font-size: 0.75rem;
    padding: 0 0.5rem;
  }
  .physical_card-spec-list-each-list button{
    display: inline-block;
    vertical-align: top;
    height: 1.5rem;
    line-height: 1.5rem;
    border-radius: 2rem;
    margin-bottom: 0.625rem;
    margin-right: 0.625rem;
    background-color: white;
    font-size: 0.75rem;
    padding: 0 0.5rem;
  }
  .physical_card-spec-num button{
    display: inline-block;
    vertical-align: top;
    /*height: 1.5rem;*/
    line-height: 1.5rem;
    border-radius: 0.1rem;
    border: 1px solid #999;
    margin-bottom: 0.625rem;
    margin-right: 0.625rem;
    background-color: white;
    color: #333312;
    font-size: 0.75rem;
    padding: 0 0.5rem;
    text-align: center;
  }
  .physical_card-spec-num div{
    display: inline-block;
    vertical-align: top;
    font-size: 1rem;
    color:#333312;
    margin-right: 0.625rem;
    height: 1.625rem;
    line-height: 1.625rem;
  }
  .physical_card-spec-button button{
    width:18.75rem;
    position: absolute;
    bottom: 0.5rem;
    background-color: #EB7AA0;
    color:white;
    font-size:1rem;
    text-align: center;
    height: 2.5rem;
    line-height: 2.5rem;
    border-radius: 2rem;
  }

  .physical_card_add_button{
    width:20rem;
    text-align: center;
    margin: 1rem auto;
  }
  .physical_card_add_button button{
    width:9rem;
    height: 2.5rem;
    line-height: 2.5rem;
    text-align: center;
    font-size: 0.875rem;
    border-radius: 2.5rem;
    padding: 0;
  }
  .physical_card_add_button_cancel{
    border:1px solid #EB7AA0;
    color:#EB7AA0;
  }
  .physical_card_add_button_sure{
    background-color:#EB7AA0;
    color:white;
    margin-left: 1.5rem;
  }
  .card_detail_spec_title{
    font-size: 1rem;
    font-weight: bold;
    color:#4a4a4a;
    height: 1.25rem;
    line-height: 1.25rem;
    text-align: center;
    margin-bottom: 0.5rem;
  }
  .card_detail_spec_changeNum{
    float: right;
    display: inline-block;
    vertical-align: top;
    background-color: #f2f2f2;
    height: 1.5rem;
    /*width:5rem;*/
  }
  .card_detail_spec_num{
    display: inline-block;
    vertical-align: top;
    background-color: white;
    /*width:1rem;*/
    height: 1.2rem;
    line-height: 1.2rem;
    text-align: center;
    width:1.4rem;
    margin-top: 0.15rem;
  }
  .card_detail_spec_low{
    width:1.6rem;
    height: 1.5rem;
    /*background-color: #ccc;*/
    font-size: 0.75rem;
    color:#636363;
    text-align: center;
    line-height: 1.5rem;
    display: inline-block;
    vertical-align: top;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/cardCurrency/physicalCardDetail.vue